import { Box, Typography } from "@mui/material";
import { t } from "i18next";

import useDimensions from "../hooks/useDimensions";
import { CorporateService } from "../models/Service";
import Chip from "../components/chip";
import StackList from "../components/stackList";
import Card from "../components/card";
import { usePayment } from "../hooks";
import { formatCurrency } from "../utils";

interface BoxBillPaymentProps {
  service: CorporateService;
  isLoading?: boolean;
}

/**
 * @deprecated Superseded by DepositFundTemplate's own bill card. Kept compiling
 * rather than deleted so the way back from the rewrite is not a revert on a live
 * payment path; removal is TODO-245, homed in Phase 15.
 */
const BoxBillPayment = ({
  service,
  isLoading = false,
}: BoxBillPaymentProps) => {
  const { isSmall } = useDimensions();
  const { customerUser, amount, currentStep } = usePayment();

  const listData = [
    {
      title: t("payment.form.customer_name"),
      value: customerUser?.name,
    },
    {
      title: t("payment.form.customer_code"),
      value: customerUser?.customer_business_no || "-",
    },
  ];

  return (
    <Box
      sx={{
        width: isSmall || currentStep === 3 ? "unset" : "40%",
        justifyContent: "center",
        marginBottom: isSmall ? 1 : 4,
      }}
    >
      {currentStep === 2 && (
        <>
          <Typography
            sx={{
              fontWeight: "600",
              fontSize: isSmall ? 16 : 20,
              textAlign: "left",
            }}
          >
            {t("payment.form.stepper_2.payment_details")}
          </Typography>
          <Typography sx={{ fontSize: 11 }}>
            {t("payment.form.stepper_2.payment_desc")}
          </Typography>
        </>
      )}

      <Card>
        <Box
          sx={{ padding: isSmall ? "8px 16px" : "10px 24px" }}
          display={"flex"}
          marginBottom={1}
          alignItems={"center"}
          justifyContent={"space-between"}
        >
          <Box>
            {t("payment.form.amount").toUpperCase()}
            <Typography variant="body1" fontSize={24} fontWeight={"700"}>
              {!!amount
                ? formatCurrency(amount, undefined, service?.currency)
                : "..."}
            </Typography>
          </Box>
          <Chip
            label={t("payment.form.not_paid")}
            variant="filled"
            status={false}
          />
        </Box>
        <Box paddingBottom={2}>
          <StackList spacing={2} list={listData} margin={2} />
        </Box>
      </Card>
    </Box>
  );
};

export default BoxBillPayment;
